import React from "react";
import PollList from "../PollList/PollList.js";
export default ({ total, pollQuestion }) => {
  const noList = {
    display: "flex",
    width: "100%",
    justifyContent: "center",
    padding: "100px 0",
    fontSize: "22px",
    fontWeight: "500",
  };
  return (
    <div className="poll-list">
      {pollQuestion.map((pollList, index) => (
        <PollList key={pollList.id} pollList={pollList} index={index} />
      ))}
      {total === 0 && <div style={noList}>You don't have any Poll Lists</div>}
    </div>
  );
};
